export default __webpack_public_path__ + "locales/ko-KR/PDFFormDialog.json?hash=a49474768fb8e873e104ed95b690bb13";